module.exports = __webpack_public_path__ + "img/erqi3.fa09e6b2.png";